import React, { Fragment, useCallback, useId, useState } from 'react'
import axios from 'lib/axios'
import Select from 'components/QuestionnaireRequest/AdminNew/components/Select'
import { clsx } from 'clsx'
import ToggleCheckbox from '../../components/checkbox'

const DisclaimerTextArea = ({
  disclaimerText: savedDisclaimerText,
  updateDisclaimerText,
  updating,
  setUpdating,
  organizationId,
}) => {
  const [disclaimerText, setDisclaimerText] = useState(savedDisclaimerText || '')

  const onSave = useCallback(async () => {
    setUpdating(true)
    const url = `/super/organizations/${organizationId}/questionnaires/update_disclaimer_text`
    await axios.post(url, {
      disclaimer_text: disclaimerText,
    })
    setUpdating(false)
    updateDisclaimerText(disclaimerText)
  }, [disclaimerText, setUpdating, updateDisclaimerText])

  return (
    <div>
      <textarea value={disclaimerText} onChange={(e) => setDisclaimerText(e.target.value)}></textarea>
      <div>
        <button
          disabled={updating}
          className={clsx('dome-btn dome-btn-base dome-btn-aqua-stroke', updating && 'dome-btn-disabled')}
          onClick={onSave}
        >
          Save
        </button>
      </div>
    </div>
  )
}

const EnableCheckbox = ({ organizationId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/super/organizations/${organizationId}/questionnaires/enable_disclaimer`
      await axios.post(url, { is_disclaimer_on: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className='dome-d-flex dome-align-start'>
      <ToggleCheckbox
        label="enable disclaimer message"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function EnableDisclaimer({
  organizationId,
  enabled,
  updateEnabled,
  disclaimerText,
  updateDisclaimerText,
}) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        organizationId={organizationId}
        enabled={enabled}
        updateEnabled={updateEnabled}
        updating={updating}
        setUpdating={setUpdating}
      />
      {enabled && (
        <DisclaimerTextArea
          organizationId={organizationId}
          disclaimerText={disclaimerText}
          updateDisclaimerText={updateDisclaimerText}
          updating={updating}
          setUpdating={setUpdating}
        />
      )}
    </div>
  )
}
